import React from "react"
import { useEffect } from "react"
import { useState } from "react"
import { useDispatch } from "react-redux"
import {
  AbonementStructure,
  getAbonementsList,
} from "src/store/Slices/AbonementsSlice"
import AbonementsGuide from "./Tables/AbonementsGuide"
import AbonementsCost from "./Tables/AbonementsCost"
import AbonementsServices from "./Tables/AbonementsServices"
import MobileAbonementsPage from "./MobileAbonements/MobileAbonementsPage"

const Abonements = ({ mnemo }) => {
  const dispatch = useDispatch()

  const [abonementInfo, setAbonementInfo] = useState(null)
  const [abonementCostInfo, setAbonementCostInfo] = useState(null)
  const [abonementSostavInfo, setAbonementSostavInfo] = useState(null)
  const [abonementServiceInfo, setAbonementServiceInfo] = useState(null)
  const [abonementStructureInfo, setAbonementStructureInfo] = useState(null)

  useEffect(() => {
    dispatch(getAbonementsList())
  }, [])

  useEffect(() => {
    if (abonementInfo?.id) {
      dispatch(
        AbonementStructure({
          abonementId: abonementInfo.id,
        })
      )
    }
  }, [abonementInfo?.id])

  return (
    <>
      {window.innerWidth >= 768 ? (
        <div>
          <AbonementsGuide
            abonementInfo={abonementInfo}
            setAbonementInfo={setAbonementInfo}
            mnemo={mnemo}
          />
          {abonementInfo && (
            <AbonementsCost
              mnemo={mnemo}
              abonementInfo={abonementInfo}
              abonementCostInfo={abonementCostInfo}
              setAbonementCostInfo={setAbonementCostInfo}
              abonementStructureInfo={abonementStructureInfo}
              setAbonementStructureInfo={setAbonementStructureInfo}
            />
          )}
          {abonementCostInfo && (
            <AbonementsServices
              mnemo={mnemo}
              abonementCostInfo={abonementCostInfo}
            />
          )}
        </div>
      ) : (
        <MobileAbonementsPage
          mnemo={mnemo}
          abonementInfo={abonementInfo}
          setAbonementInfo={setAbonementInfo}
          abonementCostInfo={abonementCostInfo}
          setAbonementCostInfo={setAbonementCostInfo}
          abonementSostavInfo={abonementSostavInfo}
          setAbonementSostavInfo={setAbonementSostavInfo}
          abonementServiceInfo={abonementServiceInfo}
          setAbonementServiceInfo={setAbonementServiceInfo}
        />
      )}
    </>
  )
}

export default Abonements
